<div
  class="modal"
  [attr.data-modaltype]="modalCSSClass"
  [attr.e2e-attr]="E2E_ATTRIBUTES.MODAL"
>
  <div class="modal-body">
    <ng-content select="modal-preheader-content"></ng-content>
    <div class="modal-header">
      <ng-content select="modal-header"></ng-content>
    </div>
    <!-- Non-scrollable intro section -->
    @if (modalCSSClass !== 'child') {
      <ng-content select="modal-intro"></ng-content>
    }
    <div class="modal-sidebar">
      @if (modalCSSClass !== 'child') {
        <ng-content select="modal-sidebar"></ng-content>
      }
    </div>
    <div class="modal-content">
      @if (modalCSSClass !== 'child') {
        <ng-content select="modal-content-title"></ng-content>
      }
      <!-- Scrollable content section -->
      <div class="modal-content-scrollable">
        <ng-content select="modal-content"></ng-content>
        <ng-content select="modal-two-columns-content"></ng-content>
      </div>

      <ng-content select="modal-content-actions"></ng-content>
    </div>
    <div class="modal-footer">
      @if (modalCSSClass !== 'child') {
        <ng-content select="modal-footer"></ng-content>
      }
    </div>
  </div>
</div>
